import PropTypes from 'prop-types'
import React from 'react'
import { renderStoryTemplate } from 'services/feed/helpers'
import injectUnits from 'shared/units/injectUnits'

export function StoryTitle ({ story, formatDistance, formatDuration }) {
  const title = renderStoryTemplate(story, formatDuration, formatDistance)

  return (
    <div dangerouslySetInnerHTML={{ __html: title }} />
  )
}

StoryTitle.propTypes = {
  story: PropTypes.object,
  formatDistance: PropTypes.func,
  formatDuration: PropTypes.func,
}

export const UnitsPage = injectUnits(StoryTitle)
export default UnitsPage
